import React, { memo, useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/app';
import { setAccount, setDrawerAccount } from '../../../redux/reducer/account';
import emitter from '../../../utilities/emitter';

const ProfitInvest = memo(({ currency, isDemo }) => {
  const dispatch = useAppDispatch();
  const isDrawer = useAppSelector(({ account }) => account?.isDrawer ?? false);
  const balance = useAppSelector(({ account }) => account?.account?.balance ?? 0);
  
  const accountBalance = useMemo(() => {
    return currency === 'USC'
      ? balance.toFixed(2)
      : balance.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        });
  }, [balance, currency]);
  const [openDropdown, setOpenDropdown] = useState(false);

  useEffect(() => {
    emitter.instance.on('accountInfo', (data) => {
      dispatch(setAccount(data));
    });
  }, []);

  useEffect(() => {
    // const data = positionProfit(openPrice, tickStore[symbol], volume, contractSize, rateProfit, isBuy)
  }, []);

  const drowDonw = () => {
    setOpenDropdown(!openDropdown);
    dispatch(setDrawerAccount(!isDrawer));
  };

  return (
    <div className="inves-content prevent-select flex items-center" onClick={() => drowDonw()}>
      {/* <div className="port">Real</div> */}
      <div className={`currency-available ${isDemo ? 'text-[#FE9F01]' : 'text-[#0FEF9E]'}`}>
        {currency === 'USC' ? (
          <span>
            <span className="leading-[0px]">¢</span>
            {`${accountBalance}`}
          </span>
        ) : (
          accountBalance
        )}
      </div>
      <div className="cursor-pointer">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            {' '}
            <path
              d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z"
              fill={isDemo ? `#FE9F01` : `#0FEF9E`}
            ></path>{' '}
          </g>
        </svg>
      </div>
    </div>
  );
});

ProfitInvest.displayName = 'ProfitInves';

export default ProfitInvest;
